"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const ecommerce_1 = require("../../api/ecommerce");
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const LoadingSpinner_1 = __importDefault(require("../../common/js/components/LoadingSpinner"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const number_1 = require("../../common/js/helper/number");
const string_1 = require("../../common/js/helper/string");
const translation_1 = require("../../common/js/helper/translation");
const Paths = __importStar(require("../constants/Paths"));
const CartErrors_1 = __importDefault(require("../enums/CartErrors"));
const lineItem_1 = require("../helper/lineItem");
const money_1 = require("../helper/money");
const product_1 = require("../helper/product");
const Route_1 = __importDefault(require("../stores/Route"));
const ShopwareCart_1 = __importDefault(require("../stores/ShopwareCart"));
const ShopwareContext_1 = __importDefault(require("../stores/ShopwareContext"));
const ShopwareProducts_1 = __importDefault(require("../stores/ShopwareProducts"));
const VoucherInput_1 = __importDefault(require("./shop/VoucherInput"));
const ShopCheckoutSummary = ({ loading }) => {
    const productLineItems = ShopwareCart_1.default.cart?.lineItems?.filter((lineItem) => lineItem.type === ecommerce_1.LineItemTypeEnum.Product);
    const promotionItems = ShopwareCart_1.default.cart?.lineItems?.filter((lineItem) => lineItem.type === ecommerce_1.LineItemTypeEnum.Promotion);
    const surchargeItems = ShopwareCart_1.default.cart?.lineItems?.filter((lineItem) => lineItem.type === ecommerce_1.LineItemTypeEnum.Surcharge);
    const netWithoutDiscounts = productLineItems?.reduce((amount, lineItem) => amount + (lineItem.price?.totalPrice ?? 0), 0);
    const taxes = (ShopwareCart_1.default.cart?.price?.calculatedTaxes ?? []).reduce((totalTax, calculatedTax) => totalTax + (calculatedTax.tax ?? 0), 0);
    const shippingCustomerIdEnabled = ShopwareContext_1.default.currentShippingMethod?.extensions?.massiveShippingMethod?.enableCustomerId ?? false;
    const shippingCustomerIdAssigned = !!ShopwareContext_1.default.contextExtension?.massiveShippingMethodCustomerId;
    const shippingUsesCustomerId = shippingCustomerIdEnabled && shippingCustomerIdAssigned;
    const fallbackShippingMethodId = ShopwareContext_1.default.contextExtension?.fallbackShippingMethodId ?? null;
    const currentShippingMethodId = ShopwareContext_1.default.currentShippingMethod?.id ?? null;
    const isFallbackShippingMethod = !!fallbackShippingMethodId && fallbackShippingMethodId === currentShippingMethodId;
    const shippingCostsNotApplicable = (isFallbackShippingMethod || shippingUsesCustomerId) && ShopwareCart_1.default.shippingCosts === 0;
    const shippingCostsFree = !shippingCostsNotApplicable && ShopwareCart_1.default.shippingCosts === 0;
    const shippingCostSum = {
        label: (0, translation_1.t)('shop_checkout_summary.sums.shipping'),
        value: shippingCostsNotApplicable
            ? (0, translation_1.t)('shop_checkout_summary.sums.shipping_not_applicable')
            : shippingCostsFree
                ? (0, translation_1.t)('shop_checkout_summary.sums.shipping_free')
                : ShopwareCart_1.default.shippingCosts,
    };
    const showTaxesAndShipping = !ShopwareContext_1.default.customFields?.massiveCheckoutHideTaxesAndShippingCosts;
    const sums = [
        showTaxesAndShipping ? { label: (0, translation_1.t)('shop_checkout_summary.sums.net'), value: netWithoutDiscounts } : null,
        ...(promotionItems?.map(({ label, price, id, payload }) => ({
            code: payload?.code,
            id,
            label: label ?? '',
            removeable: true,
            value: price?.totalPrice,
        })) ?? []),
        ...(surchargeItems?.map(({ label, price }) => ({ label: `${label ?? ''}:`, value: price?.totalPrice })) ?? []),
        showTaxesAndShipping ? shippingCostSum : null,
        showTaxesAndShipping ? { label: (0, translation_1.t)('shop_checkout_summary.sums.tax'), value: taxes } : null,
    ].filter((item) => !!item && (item.value ?? 0) !== 0);
    const currency = ShopwareContext_1.default.currency?.isoCode;
    const defer = ShopwareCart_1.default.cartErrors.find((error) => error.messageKey === CartErrors_1.default.deferredProductPrice);
    const isSummaryStep = (0, react_router_config_1.matchRoutes)([{ path: Paths.PATH_SHOP_CHECKOUT_SUMMARY }], Route_1.default.location?.pathname ?? '').length === 1;
    const showVoucherInput = (() => {
        const { software = [], softwareOffers = [], softwareWithMachine = [] } = ShopwareCart_1.default.cartGroups ?? {};
        return (ShopwareCart_1.default.cartGroups !== null &&
            software.length + softwareOffers.length + softwareWithMachine.length === 0);
    })();
    return (react_1.default.createElement("div", { className: "znd-shop-checkout-summary" },
        react_1.default.createElement("h3", { className: "znd-shop-checkout-summary__title" }, (0, translation_1.t)('shop_checkout_summary.title')),
        loading || !!defer ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "znd-shop-checkout-summary__loader mb-3" })) : (productLineItems?.map((lineItem) => {
            const product = ShopwareProducts_1.default.getProduct(lineItem.referencedId ?? '');
            const payloadDescriptions = (0, lineItem_1.getLineItemPayloadDescriptions)(lineItem);
            return product ? (react_1.default.createElement("div", { key: lineItem.referencedId, className: "znd-shop-checkout-summary__item" },
                react_1.default.createElement("div", { className: "znd-shop-checkout-summary__item-info" },
                    react_1.default.createElement("span", { className: "znd-shop-checkout-summary__item-name" }, lineItem.label),
                    payloadDescriptions.length > 0 ? (react_1.default.createElement("div", { className: "znd-shop-checkout-summary__item-payload-descriptions t-body-small" }, payloadDescriptions.map((value) => (react_1.default.createElement("div", { key: `description-${value}` }, value))))) : null,
                    react_1.default.createElement("span", { className: "znd-shop-checkout-summary__item-quantity" }, (0, translation_1.t)('shop_checkout_summary.quantity', {
                        count: lineItem.quantity ?? 0,
                        quantity: (0, number_1.numberFormat)(lineItem.quantity ?? 0),
                    })),
                    (0, product_1.showPrices)(product) && !!currency ? (react_1.default.createElement("span", { className: "znd-shop-checkout-summary__item-price" }, (0, money_1.moneyFormat)(lineItem.price?.totalPrice ?? 0, currency))) : null))) : null;
        })),
        react_1.default.createElement("footer", { className: "znd-shop-checkout-summary__sums" },
            !isSummaryStep && showVoucherInput ? react_1.default.createElement(VoucherInput_1.default, null) : null,
            !loading && !defer ? (react_1.default.createElement(react_1.default.Fragment, null,
                ShopwareCart_1.default.showPrices
                    ? sums.map(({ label, value, removeable, id, code }) => (react_1.default.createElement("div", { key: label, className: "znd-shop-checkout-summary__sum" },
                        react_1.default.createElement("span", { className: "znd-shop-checkout-summary__sum-label" },
                            code
                                ? (0, translation_1.t)('shop_checkout_summary.sums.voucher_code', {
                                    code: (0, string_1.ellipsis)(code, 20),
                                })
                                : label,
                            removeable && id && !isSummaryStep ? (react_1.default.createElement("button", { className: "text-primary ml-1 znd-shop-checkout-summary__promotion-remove", onClick: () => {
                                    ShopwareCart_1.default.removeLineItemFromCart(id);
                                } },
                                react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.trash }))) : null),
                        react_1.default.createElement("span", { className: "znd-shop-checkout-summary__sum-price" },
                            value < 0 ? '– ' : null,
                            isNaN(Number(value)) || !currency
                                ? value
                                : (0, money_1.moneyFormat)(Math.abs(Number(value)), currency)))))
                    : null,
                !!ShopwareCart_1.default.cart?.price?.totalPrice && ShopwareCart_1.default.showPrices && !!currency ? (react_1.default.createElement("div", { className: "znd-shop-checkout-summary__sum znd-shop-checkout-summary__sum--total" },
                    react_1.default.createElement("span", { className: "znd-shop-checkout-summary__sum-label" }, (0, translation_1.t)('shop_checkout_summary.sums.total')),
                    react_1.default.createElement("span", { className: "znd-shop-checkout-summary__sum-price" }, (0, money_1.moneyFormat)(ShopwareCart_1.default.cart?.price?.totalPrice, currency)))) : null)) : null)));
};
exports.default = (0, mobx_react_1.observer)(ShopCheckoutSummary);
